import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Bomberos from "./pages/Bomberos";
import Hidraulica from "./pages/Hidraulica";
import LandingCercas from "./pages/LandingCercas";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./pages/NotFound";
import LandingHabilitaciones from "./pages/LandingHabilitaciones";
import LandingCarteleria from "./pages/LandingCarteleria";
import Drones from './pages/Drones'
import Financiamiento from './pages/Financiamiento';

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />            
             {/* Rutas de Drones */}
            <Route path="/drones" element={<Drones/>}>
            </Route>
            {/* Rutas de Bomberos */}
            <Route path="/bomberos" element={<Bomberos />}>            
            </Route>
            <Route path="/hidraulica" element={<Hidraulica />}>            
            </Route>
            <Route path="/habilitacion-de-bomberos" element={<LandingHabilitaciones />}>            
            </Route>
            {/* Rutas de Seguridad */}
            <Route path="/cercas-electricas" element={<LandingCercas />}>            
            </Route>
             {/* Rutas de Carteleria */}
             <Route path="/carteleria" element={<LandingCarteleria />}>            
            </Route>
            {/* Rutas de Financiamiento */}
            <Route path="/financiamiento" element={<Financiamiento/>}></Route>
            <Route path="/#contacto" element={<Home />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>      
        <Footer />
      </Router>
    </div>
  );
}

export default App;